<div class="snapshot-container">
  <!-- Loading -->
  <div *ngIf="showSpinner" class="d-flex justify-content-center align-items-center py-5">
    <div class="spinner-border text-primary" style="width: 4rem; height: 4rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Error -->
  <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

  <!-- Empty -->
  <div class="empty-state" *ngIf="showDataMissing">
    <i class="bi bi-search empty-state-icon"></i>
    <h4>No Clusters Found</h4>
    <p>No clusters matched the selected universe filters.</p>
  </div>

  <ng-container *ngIf="showContent && snapshot">
    <!-- Top / Flop tables -->
    <div class="tables-grid">
      <!-- Top Growing -->
      <div class="result-card">
        <div class="result-card-header">
          <i class="bi bi-arrow-up-right-circle-fill header-icon text-success"></i>
          <h5>Top 10 Accelerating Technologies</h5>
        </div>
        <div class="result-card-body">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Technologies <i class="bi bi-info-circle info-icon" (click)="openInfoPopup('theme_clusters')"></i>
                </th>
                <th>Stage <i class="bi bi-info-circle info-icon" (click)="openInfoPopup('theme_stages')"></i></th>
                <th class="text-center">
                  Absolute Growth (12m)
                  <i class="bi bi-info-circle info-icon"
                    matTooltip="Absolute Growth shows the number of inventions published in this cluster field within the last 12 months by companies within your universe."
                    matTooltipPosition="above"></i>
                </th>
                <th class="text-center">
                  Relative Growth (12m, %)
                  <i class="bi bi-info-circle info-icon"
                    matTooltip="Relative Growth shows the relative increase/decrease in resource allocation, comparing the absolute growth of the last 12m to the previous 12 months."
                    matTooltipPosition="above"></i>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let c of snapshot.top_clusters; let i = index; trackBy: trackCluster">
                <tr>
                  <td class="text-center">
                    <span class="expand-icon" role="button" (click)="toggleTopExpand(i)">
                      <i [class]="topExpanded === i ? 'bi bi-dash-circle-fill' : 'bi bi-plus-circle-fill'"></i>
                    </span>
                  </td>
                  <td class="cell-cluster" [matTooltip]="c.cluster_name" matTooltipPosition="above">{{ c.cluster_name }}
                  </td>
                  <td>
                    <span class="stage-badge" [style.background-color]="stageBgColor(c.stage)"
                      [style.color]="stageColor(c.stage)">
                      {{ stageLabel(c.stage) }}
                    </span>
                  </td>
                  <td class="text-center">{{ c.invention_count_12m | nullableNumber:'1.0-0' }}</td>
                  <td class="text-center fw-semibold text-success">
                    {{ c.relative_growth | nullableNumber:'1.2-2' }}%
                  </td>
                  <td>
                    <button class="btn-explore-row"
                      (click)="submitCluster(c.cluster_id, c.cluster_name)">Explore</button>
                  </td>
                </tr>
                <tr *ngIf="topExpanded === i" class="collapse-row">
                  <td colspan="6">
                    <div class="company-panel">
                      <div class="company-col">
                        <h6>Top {{ c.top_companies.length }} Companies</h6>
                        <table class="company-table">
                          <thead>
                            <tr>
                              <th>Company</th>
                              <th class="text-center">Abs Growth (12m)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let co of c.top_companies">
                              <td class="company-name">{{ co.ent_name }}</td>
                              <td class="text-center company-count">{{ co.invention_count | nullableNumber:'1.0-0' }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Flop Declining -->
      <div class="result-card">
        <div class="result-card-header">
          <i class="bi bi-arrow-down-right-circle-fill header-icon text-danger"></i>
          <h5>Largest 10 Declining Technologies</h5>
        </div>
        <div class="result-card-body">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Technologies <i class="bi bi-info-circle info-icon" (click)="openInfoPopup('theme_clusters')"></i>
                </th>
                <th>Stage <i class="bi bi-info-circle info-icon" (click)="openInfoPopup('theme_stages')"></i></th>
                <th class="text-center">
                  Absolute Growth (12m)
                  <i class="bi bi-info-circle info-icon"
                    matTooltip="Absolute Growth shows the number of inventions published in this cluster field within the last 12 months by companies within your universe."
                    matTooltipPosition="above"></i>
                </th>
                <th class="text-center">
                  Relative Growth (12m, %)
                  <i class="bi bi-info-circle info-icon"
                    matTooltip="Relative Growth shows the relative increase/decrease in resource allocation, comparing the absolute growth of the last 12m to the previous 12 months."
                    matTooltipPosition="above"></i>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let c of snapshot.flop_clusters; let i = index; trackBy: trackCluster">
                <tr>
                  <td class="text-center">
                    <span class="expand-icon" role="button" (click)="toggleFlopExpand(i)">
                      <i [class]="flopExpanded === i ? 'bi bi-dash-circle-fill' : 'bi bi-plus-circle-fill'"></i>
                    </span>
                  </td>
                  <td class="cell-cluster" [matTooltip]="c.cluster_name" matTooltipPosition="above">{{ c.cluster_name }}
                  </td>
                  <td>
                    <span class="stage-badge" [style.background-color]="stageBgColor(c.stage)"
                      [style.color]="stageColor(c.stage)">
                      {{ stageLabel(c.stage) }}
                    </span>
                  </td>
                  <td class="text-center">{{ c.invention_count_12m | nullableNumber:'1.0-0' }}</td>
                  <td class="text-center fw-semibold text-danger">
                    {{ c.relative_growth | nullableNumber:'1.2-2' }}%
                  </td>
                  <td>
                    <button class="btn-explore-row"
                      (click)="submitCluster(c.cluster_id, c.cluster_name)">Explore</button>
                  </td>
                </tr>
                <tr *ngIf="flopExpanded === i" class="collapse-row">
                  <td colspan="6">
                    <div class="company-panel">
                      <div class="company-col">
                        <h6>Top {{ c.top_companies.length }} Companies</h6>
                        <table class="company-table">
                          <thead>
                            <tr>
                              <th>Company</th>
                              <th class="text-center">Abs Growth (12m)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let co of c.top_companies">
                              <td class="company-name">{{ co.ent_name }}</td>
                              <td class="text-center company-count">{{ co.invention_count | nullableNumber:'1.0-0' }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Selected theme banner — appears above the treemap when a cluster is clicked -->
    <!-- <div class="selectedTheme" *ngIf="selectedCluster">
      <h4>Selected Theme: <strong>{{ selectedCluster.cluster_name }}</strong></h4>
      <button class="btn search-button" (click)="exploreSelected()">Explore</button>
    </div> -->

    <!-- Innovation Landscape description -->
    <!-- <div class="result-card landscape-info-card">
      <div class="result-card-header">
        <h5>Innovation Landscape</h5>
      </div>
      <div class="landscape-info-body">
        <p>Our Innovation Landscape shows how research and development (R&amp;D) resources are spread across different technology fields:</p>
        <ul>
          <li><strong>Size of Each Field:</strong> Indicates the absolute growth of the technology area in the last 12 months, highlighting the most active fields when it comes to inventions filed.</li>
          <li><strong>Color of Each Field:</strong> Shows the relative growth compared to the previous 12 months, highlighting fields with the most potential.</li>
        </ul>
      </div>
    </div> -->

    <!-- Treemap -->
    <!-- <div class="result-card treemap-card">
      <plotly-plot *ngIf="treemapFigure"
                   [data]="treemapFigure.data"
                   [layout]="treemapFigure.layout"
                   [config]="treemapFigure.config"
                   [useResizeHandler]="true"
                   [style]="{ width: '100%' }"
                   (plotlyClick)="onTreemapClick($event)">
      </plotly-plot>
    </div> -->
  </ng-container>
</div>